import React, { useState, useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import CartCanvas from "../pages/canvas/CartCanvas";
import LoginCanvas from "../pages/canvas/LoginCanvas";
import RegisterCanvas from "../pages/canvas/RegisterCanvas";
import Auth from "../utils/AuthUtils";
import { useCart } from "../context/CartContext";
import SearchCanvas from "../pages/canvas/SearchCanvas";
import { Container, Nav, Form, InputGroup } from "react-bootstrap";
import { Menu, User, Search, Heart, ShoppingBag } from "lucide-react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";

function Header() {
  const [searchText, setSearchText] = useState("");
  const [showSearchModal, setShowSearchModal] = useState(false);
  const { cartItems } = useCart();
  const { config } = useSiteConfig();
  const isLoggedIn = Auth.getToken();
  const { categories } = useContext(CategoryContext);
  const [openId, setOpenId] = useState(null);

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  if (!config) return null;

  const handleModalShow = () => {
    setShowSearchModal(true);
  };

  return (
    <>
      {/* MAIN HEADER */}
      <header className="custom-header-wrapper">
        {/* top bar */}
        <div className="custom-header-topbar py-2">
         <div className="container ">
           <div  className=" d-flex justify-content-between align-items-center">
            <div className="custom-header-top-left">
              <span>Made for Fast India</span>
            </div>

            <div className="custom-header-top-right">
              <Link to='/bulk-enquiry' className="enquiry-btn">Bulk Enquiry</Link>
            </div>
          </div>
         </div>
        </div>
        <div className="custom-header-navbar py-1 navbar-dark border-none">
          <Container className="d-flex align-items-center justify-content-between px-0">
            {/* LEFT */}
            <Link to="/" className="custom-header-logo">
              <img src={config?.logo} alt="logo" />
            </Link>

            <div className="justify-content-center">
              <Nav className="custom-header-nav">
                <Nav.Link as={Link} to="/" className="custom-header-link ">
                  Home
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/about-us"
                  className="custom-header-link"
                >
                  About Us
                </Nav.Link>
                <Nav.Link as={Link} to="/shop" className="custom-header-link">
                  Shop
                </Nav.Link>

                {/* <div className="custom-nav-dropdown">
                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    className="custom-header-link"
                  >
                    About
                  </Nav.Link>

                  <div className="custom-dropdown-menu">
                    <Link to="/about-us" className="custom-dropdown-item">
                      About Us
                    </Link>

                    <Link to="/shop" className="custom-dropdown-item">
                      Shop
                    </Link>

                    <Link to="/blog" className="custom-dropdown-item">
                      Our Blogs
                    </Link>
                  </div>
                </div> */}

                {categories.map((cat) => (
                  <div className="custom-nav-dropdown" key={cat._id}>
                    <Nav.Link
                      as={Link}
                      to={`/categories/${cat.slugPath}`}
                      className="custom-header-link"
                    >
                      {cat.name}
                    </Nav.Link>

                    {cat.children && cat.children.length > 0 && (
                      <div className="custom-dropdown-menu">
                        {cat.children.map((sub) => (
                          <Link
                            key={sub._id}
                            to={`/categories/${sub.slugPath}`}
                            className="custom-dropdown-item"
                          >
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ))}

                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  className="custom-header-link"
                >
                  Contact
                </Nav.Link>
              </Nav>
            </div>

            {/* RIGHT */}
            <div className="custom-header-right d-flex align-items-center gap-3">
              <div className="custom-header-search-box">
                <div
                  className="bg-transparent"
                  onClick={() => setShowSearchModal(true)}
                >
                  <Search size={20} strokeWidth={2.4} className="custom-header-icon " />
                </div>
              </div>

              <Link to="/wishlist" className="d-block text-decoration-none">
                <Heart size={20} strokeWidth={2.4} className=" custom-header-icon " />
              </Link>

              <div className="d-none d-md-block">
                {isLoggedIn ? (
                  <Link to="/users/dashboard">
                    <User size={20} strokeWidth={2.4} className="custom-header-icon " />
                  </Link>
                ) : (
                  <Link to="/users/login">
                    <User size={20} strokeWidth={2.4} className="custom-header-icon " />
                  </Link>
                )}
              </div>

              <button
                data-bs-toggle="offcanvas"
                data-bs-target="#shoppingCartCanvas"
                className=" bg-transparent border-0 p-0 d-block"
              >
                <ShoppingBag
                  size={20} strokeWidth={2.4}
                  className="custom-header-icon "
                />
              </button>
              <button
                data-bs-toggle="offcanvas"
                data-bs-target="#mobileMenu"
                className="custom-mobile-menu-btn d-lg-none custom-header-icon"
              >
                <Menu size={20} strokeWidth={2.4} />
              </button>
            </div>
          </Container>
        </div>
      </header>

      <SearchCanvas
        isOpen={showSearchModal}
        searchText={searchText}
        setSearchText={setSearchText}
        onClose={() => setShowSearchModal(false)}
      />

      <div
        className="offcanvas offcanvas-end custom-cart-offcanvas"
        id="shoppingCartCanvas"
      >
        <CartCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="loginOffCanvas"
      >
        <LoginCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="registerOffCanvas"
      >
        <RegisterCanvas />
      </div>

      <div className="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
        <button
          className="icon-close icon-close-popup"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
        <div className="mb-canvas-content">
          <div className="mb-body">
            <div className="mb-content-top">
              <ul className="nav-ul-mb" id="wrapper-menu-navigation">
                <li className="nav-mb-item">
                  <Link to="/" className="mb-menu-link text-decoration-none">
                    Home
                  </Link>
                </li>
                 <li className="nav-mb-item">
                  <Link to="/about-us" className="mb-menu-link text-decoration-none">
                    About
                  </Link>
                </li>
                 <li className="nav-mb-item">
                  <Link to="/shop" className="mb-menu-link text-decoration-none">
                    Shop
                  </Link>
                </li>
               

                {/* <li className="nav-mb-item">
                  <div
                    className="mb-menu-link d-flex justify-content-between align-items-center"
                    onClick={() => handleToggle("about-mb")}
                    style={{ cursor: "pointer" }}
                  >
                    About
                    <span className="plus-minus-icon">
                      {openId === "about-mb" ? "-" : "+"}
                    </span>
                  </div>

                  {openId === "about-mb" && (
                    <div className="dropdown-menu show border-0 ps-3 bg-transparent">
                      <Link to="/about-us" className="dropdown-item py-2">
                        About Us
                      </Link>
                      <Link to="/blog" className="dropdown-item py-2">
                        Blogs
                      </Link>
                      <Link to="/shop" className="dropdown-item py-2">
                        Shop
                      </Link>
                    </div>
                  )}
                </li> */}

                {categories.map((cat) => (
                  <li className="nav-mb-item" key={cat._id}>
                    <div
                      className="mb-menu-link nav-item-dropdown d-flex justify-content-between"
                      onClick={() => handleToggle(cat._id)}
                    >
                      {cat.name}
                      <span>{openId === cat._id ? "-" : "+"}</span>
                    </div>
                    {cat.children?.length > 0 && openId === cat._id && (
                      <div className="dropdown-menu show">
                        {cat.children.map((sub) => (
                          <Link
                            key={sub._id}
                            to={`/categories/${sub.slugPath}`}
                            className="dropdown-item"
                          >
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </li>
                ))}
                  <li className="nav-mb-item">
                  <Link to="/blog" className="mb-menu-link text-decoration-none">
                    Blogs
                  </Link>
                </li>
                <li className="nav-mb-item">
                  <Link to="/contact-us" className="mb-menu-link text-decoration-none">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="mb-other-content">
              <div className="group-icon">
                {!isLoggedIn ? (
                  <Link to="/users/login" className="shop-btn px-4">
                    <i className="icon icon-user me-2" /> Login
                  </Link>
                ) : (
                  <Link to="/users/dashboard" className="shop-btn px-4">
                    <i className="icon icon-user me-2" /> Dashboard
                  </Link>
                )}
              </div>
              <div className="mb-contact mb-0 border-bottom border-muted">
                <p>
                  Address:
                  <span className="ms-1">
                    {[
                      config?.address?.addressLine,
                      config?.address?.district,
                      config?.address?.state,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                    {config?.address?.pincode
                      ? ` - ${config?.address.pincode}`
                      : ""}
                  </span>
                </p>
              </div>
              <ul className="p-0">
                <li className="pt-3">
                  Email:{" "}
                  <b className="fw-medium">
                    <a
                      className="text-decoration-none text-secondary"
                      href={`mailto: ${config.email}`}
                    >
                      {config.email}
                    </a>
                  </b>
                </li>
                <li>
                  Phone:
                  <b className="fw-medium">
                    <a
                      className="text-decoration-none text-secondary"
                      href={`tel: ${config.phone}`}
                    >
                      +91-{config.phone}
                    </a>
                  </b>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
